export default {
    USER_ID: 'user_fhHdeRUKTHViLaPa9uilR',
    TEMPLATE_ID: 'template_b9ymz8o',
    SERVICE_ID: 'service_4r0qr7f'
}